import { useEffect } from 'react';
import { startSelectEnhancer } from './selectDropdown';

/** Mounted once at the root: gives every dropdown in the app the modern look (see selectDropdown.ts). Renders nothing. */
export function SelectEnhancer() {
  useEffect(() => startSelectEnhancer(), []);
  return null;
}
